const styles = {
  wrapper: 'content-box xl:max-w-5xl lg:max-w-3xl md:max-w-none py-16 relative',
  header: 'flex justify-between items-end mb-6',
  heading: 'text-h2 text-pink',
  listWrapper:
    'relative flex flex-col items-center justify-center border-t border-black-light',
};

export default styles;
